import styled from 'styled-components';

export const LocationHeader = styled.p`
    color: #6488ca;
    margin: 0;
`
export const LocationText = styled.p`
    margin-top: 20px;
    line-height: 25px;
`
export const LocationWrapper = styled.div`
    margin-right: 20px;
    min-width: 176px;
`